import { experimentalStyled as styled } from "@mui/material/styles";
import { SvgIcon } from "@mui/material";
const StyledSvgIcon = styled(SvgIcon)({
  width: "inherit",
  height: "inherit",
});
export { StyledSvgIcon };
